/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_DownloadInputs */



/**
* | output |
* | --- |
* | "Batch Download" |
*
* @param {Batch_DownloadInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_download = /** @type {((inputs?: Batch_DownloadInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_DownloadInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléchargement par lots")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stapelverarbeitung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Download in blocco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пакетная загрузка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descarga por lotes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批量下载")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バッチダウンロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच डाउनलोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Download em lote")
	return /** @type {LocalizedString} */ ("Batch Download")
});